import axios from "axios";

/**
 * @property {string} payUrl - Url de PayU para la integracion.
 * @property {string} merchantId - Identificador de tu tienda en el sistema de PayU, puedes encontrar este número en el correo de creación de tu cuenta.
 * @property {string} accountId - Codigo de la cuenta creada.
 * @property {boolean} description - Descriptcion del producto que se va a pagar.
 * @property {string} referenceCode - Referencia de la venta o la orden. Debe ser única por cada transacción enviada al sistema. Usualmente, esta es una forma de identificar las peticiones enviadas a la pasarela de pagos.
 * @property {string} amount - Valor total de la transacción. Puede tener dos cifras decimales. Ejemplo 10000.00 o 10000.
 * @property {string} currency - Moneda con la que se va hacer el pago COP o USD.
 * @property {string} taxt - Valor del impuesto al valor agregado de la transacción.
                            En Colombia, si no se envía el IVA. el sistema aplica automáticamente el 19%. Puede tener dos dígitos decimales, por ejemplo 19000.00.
                            Si el producto o servicio es exento de impuesto al valor agregado, asigne 0 a esta variable.  .
 * @property {string} taxReturnBase - Valor base para la devolución de impuestos.
                                    Si el producto o servicio es exento de impuesto al valor agregado, asigne 0 a esta variable..
 * @property {string} signature - Firma digital creada por cada transacción.
 * @property {string} test - Indica si la transacción es en modo pruebas o en producción. Asigna 1 para pruebas y 0 para producción.
 */

/**
 * Get la informacion necesaria para poder hacer la integracion con PayU
 * @returns {Promise.<Array<PayU>>} Lista de elementos del curso
 */
export async function getPaymentPayUData() {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/payments/payu`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

/**
 * Crea una preferencia de pago en Mercado Pago (Checkout Pro)
 * @returns {Promise<Object>} Preferencia creada con init_point y metadata
 */
export async function createMercadoPagoPreference() {
  return axios
    .post(
      `${import.meta.env.VITE_API_BASE_URL}/api/payments/mercadopago/preference`,
      {}
    )
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

/**
 * Crea un checkout de Lemon Squeezy para el usuario autenticado.
 * @returns {Promise<Object>} Datos del checkout con la URL para redirigir.
 */
export async function createLemonSqueezyCheckout() {
  return axios
    .post(
      `${import.meta.env.VITE_API_BASE_URL}/api/payments/lemonsqueezy/checkout`,
      {}
    )
    .then((response) => response.data)
    .catch((err) => console.error(err));
}
